export default () => {
  //Todo: Make this generic so we do not lose the type of the object
  const removeRecordDates = (obj: any): any => {
    const newObj = JSON.parse(JSON.stringify(obj));
    delete newObj.createdAt;
    delete newObj.deletedAt;
    delete newObj.updatedAt;
    delete newObj.created_at;
    delete newObj.deleted_at;
    delete newObj.updated_at;
    return newObj;
  };

  return { removeRecordDates };
};
